var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('j-card-text',{staticClass:"pt-4"},[_c('j-graphic',{attrs:{"src":_vm.article.badge_src,"alt":_vm.article.title,"aspect-ratio":"1","width":"100%"}}),_c('ArticleBody',{staticClass:"staff-pick-review pa-2",attrs:{"article":_vm.article}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }